



















import { Component, Vue } from 'vue-property-decorator';
import AddGroupModal from '../components/modals/addGroupModal.vue';
import * as api from '@/api';

@Component({
    components: {
        AddGroupModal
    }
})
export default class OncallGroupSetting extends Vue {
    groupList: CommonTypes.mapObject[] = [];
    groupData: CommonTypes.mapObject = {};
    modalType: 'add' | 'update' = 'add';
    showGroupModal: boolean = false;
    tableLoading: boolean = false;

    created() {
        this.getGroups();
    }
    async getGroups() {
        this.tableLoading = true;
        try {
            const res = await api.oncallApi.getRgGroups({
                rgId: this.rgId
            });
            const { data, code } = res;
            if (code === 200 && data) {
                this.tableLoading = false;
                this.groupList = data.items || [];
            }
        } catch (e) {
            this.tableLoading = false;
            console.log(e);
        }
    }
    onAddSuccess() {
        this.getGroups();
    }
    addOncallGroup() {
        this.groupData = {};
        this.modalType = 'add';
        this.showGroupModal = true;
    }
    get operations() {
        return [
            {
                label: '编辑',
                action: 'edit',
                props: {
                    class: 'table-link'
                },
                click: (action: string, scope: any) => {
                    this.groupData = scope.row;
                    this.modalType = 'update';
                    this.showGroupModal = true;
                }
            },
            {
                label: '删除',
                action: 'delete',
                props: {
                    class: 'table-link'
                },
                click: (action: string, scope: any) => {
                    this.$mtd
                        .confirm({
                            title: '是否确认删除该值班组？',
                            width: '433px',
                            showCancelButton: true,
                            type: 'warning',
                            className: 'common-modal',
                            okButtonProps: {
                                type: 'danger',
                                class: 'tt-pure-btn'
                            },
                            cancelButtonProps: {
                                class: 'tt-pure-btn'
                            },
                            onOk: async () => {
                                try {
                                    const res = await api.oncallApi.deleteRgGroup(scope.row.identify);
                                    const { code } = res;
                                    if (code === 200) {
                                        this.$mtd.message({
                                            message: '删除值班组成功',
                                            type: 'success'
                                        });
                                        this.getGroups();
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                        })
                        .catch(e => e);
                }
            }
        ];
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
